import React from 'react'
import { Folder, FileText, ChevronRight } from 'lucide-react'
import type { TaxonomyNode } from '../../types'

interface SubjectCardProps {
  node: TaxonomyNode
  onClick: (node: TaxonomyNode) => void
}

const SubjectCard: React.FC<SubjectCardProps> = ({ node, onClick }) => {
  return (
    <button
      onClick={() => onClick(node)}
      className="w-full text-left bg-white border border-gray-200 rounded-xl p-4
                 hover:shadow-md hover:border-acad-200 transition-all duration-200
                 group focus:outline-none focus:ring-2 focus:ring-acad-500 focus:ring-offset-1"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          {/* Subject label */}
          <h3 className="text-sm font-semibold text-gray-800 group-hover:text-acad-600
                         transition-colors truncate">
            {node.label}
          </h3>

          {/* Counts */}
          <div className="flex items-center gap-3 mt-2">
            {node.resource_count > 0 && (
              <div className="flex items-center gap-1 text-xs text-gray-500">
                <FileText className="w-3.5 h-3.5" />
                <span>{node.resource_count.toLocaleString()} resource{node.resource_count !== 1 ? 's' : ''}</span>
              </div>
            )}
            {node.children_count > 0 && (
              <div className="flex items-center gap-1 text-xs text-gray-500">
                <Folder className="w-3.5 h-3.5" />
                <span>{node.children_count} sub-area{node.children_count !== 1 ? 's' : ''}</span>
              </div>
            )}
          </div>
        </div>

        {/* Navigate arrow */}
        <div className="shrink-0 mt-1">
          <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-acad-500
                                    transition-colors" />
        </div>
      </div>
    </button>
  )
}

export default SubjectCard
